import { render, staticRenderFns } from "./dui-progress-bar.vue?vue&type=template&id=81f6a022&scoped=true&"
import script from "./dui-progress-bar.vue?vue&type=script&lang=js&"
export * from "./dui-progress-bar.vue?vue&type=script&lang=js&"
import style0 from "./dui-progress-bar.vue?vue&type=style&index=0&id=81f6a022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f6a022",
  null
  
)

export default component.exports